<template>
  <section class="home-base-list-sec">
    <div class="home-base-list__inner pis-container">
      <div
        v-if="base_list_static"
        class="row no-gutters justify-content-center"
      >
        <div
          class="col-6 col-sm-2  col-lg"
          v-for="base in base_list_static"
          v-bind:key="base.id"
        >
          <div :class="'home-base__card  text-center base_' + base.extCode">
            <div class="home-base__card-inner ">
              <div class="home-base__card-icon ">
                <span
                  :class="
                    base.class +
                      '_color ' +
                      'icon-pis-color icon-' +
                      base.extCode
                  "
                ></span>
              </div>
              <div class="home-base__card-header">
                <h3 class="home-base__card-title">
                  <a
                    v-if="base.extCode === 'LIE'"
                    v-html="base.name"
                    :href="base.link"
                    target="_blank"
                  >
                  </a>
                  <router-link v-else v-html="base.name" :to="base.link">
                  </router-link>
                </h3>
              </div>
              <div class="home-base__card-bottom">
                <div class="home-base__card-link-sec">
                  <a
                    v-if="base.extCode === 'LIE'"
                    :class="{
                      'home-base__card-link  ': true,
                      'animated-icon': base.children,
                    }"
                    :href="base.link"
                    target="_blank"
                  >
                    <span class="icon-chevron-right "></span>
                  </a>
                  <router-link
                    v-else
                    :to="base.link"
                    :class="{
                      'home-base__card-link  ': true,
                      'animated-icon': base.children,
                    }"
                  >
                    <span class="icon-chevron-right "></span>
                  </router-link>
                </div>
              </div>
              <div class="home-base__card-footer "></div>
            </div>

            <div class="home-base__card-menu ">
              <ul
                v-if="base.children"
                class="home-base__card-nav nav flex-column"
              >
                <li
                  class="home-base__card-nav-item nav-item"
                  v-for="(child, index) in base.children"
                  v-bind:key="index"
                >
                  <router-link
                    v-html="child.name"
                    class="nav-link"
                    :to="'/' + child.link"
                  >
                  </router-link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
// import axios from 'axios';

export default {
  name: "HomeBaseListSec",
  data() {
    return {
      base_list: [],
      base_list_static: [
        {
          extCode: "TGGROUP",
          id: 1,
          name: "Службени гласник Републике Србије",
          icon: "book",
          class: "pis_slglrs",
          link: "/slglrsNP-overview/all",
          children: [
            {
              name: "Службени гласник РС",
              link: "slglrsNP-overview/all",
            },
            {
              name: "Службени гласник РС - Међународни уговори",
              link: "slglrsMUTG-overview/all",
            },
            {
              name: "Службени гласник РС - Просветни гласник",
              link: "slglrsPG2010-overview/all",
            },
          ],
        },
        {
          extCode: "ARHGROUP",
          id: 2,
          name: "Архива службених гласила",
          icon: "inbox",
          class: "pis_arhslgl",
          link: "/arhslgl-sgarh",
          children: [
            {
              name: "Архива Службеног гласника",
              link: "arhslgl-sgarh",
            },
            {
              name: "Архива Просветног гласника",
              link: "arhslgl-pgarh",
            },
            {
              name: "Архива Службеног листа",
              link: "arhslgl-slarh",
            },
            {
              name: "Архива ратификованих међународних уговора и других аката",
              link: "arhslgl-muarh",
            },
          ],
        },
        {
          extCode: "REG",
          id: 3,
          name:
            "\u0420\u0435\u0433\u0438\u0441\u0442\u0430\u0440 \u0438 \u0442\u0435\u043a\u0441\u0442\u043e\u0432\u0438 \u0432\u0430\u0436\u0435\u045b\u0438\u0445 \u043f\u0440\u043e\u043f\u0438\u0441\u0430 \u0438 \u0434\u0440\u0443\u0433\u0438\u0445 \u0430\u043a\u0430\u0442\u0430",
          icon: "law",
          class: "pis_reg",
          link: "reg-overview",
          children: null,
        },
        {
          extCode: "SP",
          id: 4,
          name:
            "\u0421\u0443\u0434\u0441\u043a\u0430 \u043f\u0440\u0430\u043a\u0441\u0430",
          icon: "auction",
          class: "pis_supa",
          link: "supa-standardSearch",
          children: null,
        },
        {
          extCode: "LIE",
          id: 5,
          name:
            "\u041f\u0440\u043e\u043f\u0438\u0441\u0438 \u043d\u0430 \u0435\u043d\u0433\u043b\u0435\u0441\u043a\u043e\u043c \u0458\u0435\u0437\u0438\u043a\u0443",
          icon: "law-en",
          class: "pis_laen",
          link: window.env.VUE_APP_EN_BASE_URL_PRODUCTION,
          children: null,
        },
        {
          extCode: "LSD",
          id: 6,
          name:
            "\u041c\u0438\u0448\u0459\u0435\u045a\u0430, \u043c\u043e\u0434\u0435\u043b\u0438, \u043b\u0438\u0442\u0435\u0440\u0430\u0442\u0443\u0440\u0430",
          icon: "open-book",
          class: "pis_mml",
          link: "mml-standard-search",
          children: null,
        },
        {
          extCode: "WPPGROUP",
          id: 7,
          name: "Посебни програмски пакети",
          icon: "box",
          class: "pis_ppp",
          link: "pp-content/WPP_ESZLJP_GUIDE",
          children: [
            {
              name: "Водич кроз пресуде Европског суда за људска права",
              link: "pp-content/WPP_ESZLJP_GUIDE",
            },
            {
              name: "Кривична дела у судској пракси",
              link: "pp-content/WPP_KD",
            },
            {
              name: "Прописи града Београда",
              link: "regulations-overview",
            },
          ],
        },
      ],

      baseApiUrl: window.env.VUE_APP_API_URL_PRODUCTION,
    };
  },
  computed: {
    // pageClass() {
    //     //this.$route.matched[0].props.default.pageClass
    //     return "test-class"
    // }
  },
  methods: {
    // fetchData() {
    //     axios.get(this.baseApiUrl + 'api/fp/menu').then(response => {
    //         // console.log("base_list : ", response);
    //         this.base_list = response.data
    //     })
    //
    // },
  },
  created() {
    // Fetch Data
    // this.fetchData();
  },
};
</script>
